// ElectrikCarousel.js
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";

function ElectrikCarousel({ items, renderSlide, containerStyle }) {
  return (
    // Spread any containerStyle from props, but ensure no forced height
    <div style={{ ...containerStyle, overflow: "hidden" }}>
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView="auto"
        coverflowEffect={{
          rotate: 20,
          stretch: 0,
          depth: 60,
          modifier: 1,
          slideShadows: false, // No shadows
        }}
        navigation={true}
        modules={[EffectCoverflow, Navigation]}
        // Let Swiper auto-size
        style={{ width: "100%", height: "auto" }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index} style={{ width: "280px" }}>
            {renderSlide(item, index)}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default ElectrikCarousel;
